import React from "react";

import { adaptAcaaData } from "./helpers/adapters";
import { AdvancedCareActivityForm } from "./components/AdvancedCareActivityForm";

export const AdvancedCareActivityView = ({
  isEditing = false,
  isEmbedded = false,
  nameToSign,
  note,
  refetchNote,
  setIsEditing,
}) => {
  return (
    <AdvancedCareActivityForm
      isEditing={isEditing}
      isEmbedded={isEmbedded}
      nameToSign={nameToSign}
      noteState={adaptAcaaData(note)}
      patientId={note.patient_id}
      refetchNote={refetchNote}
      setIsEditing={setIsEditing}
    />
  );
};
